import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { t } from '../../../modules/infra/i18n';

import CurrencyInput from '../../common/currencyInput';
import CheckboxSwitch from '../../common/checkboxSwitch';
import PercentageInput from '../../common/percentageInput';
import { SHOP_TYPE } from './constants';
import Icon, { GLYPHS } from '../../common/icon';

const renderFees = currency => (
  <div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:shop_form.fees.card_not_present_flat_fee')}</div>
      <CurrencyInput
        className="c-input"
        placeholder={t('admin:shop_form.fees.card_not_present_flat_fee')}
        name="creditCardFlatFee"
        currency={currency}
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:shop_form.fees.card_not_present_percent_fee')}
      </div>
      <PercentageInput
        className="c-input"
        placeholder={t('admin:shop_form.fees.card_not_present_percent_fee')}
        name="creditCardPercentFee"
        currency={currency}
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:shop_form.fees.amex_card_not_present_flat_fee')}</div>
      <CurrencyInput
        className="c-input"
        placeholder={t('admin:shop_form.fees.amex_card_not_present_flat_fee')}
        name="amexCreditCardFlatFee"
        currency={currency}
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:shop_form.fees.amex_card_not_present_percent_fee')}</div>
      <PercentageInput
        className="c-input"
        placeholder={t('admin:shop_form.fees.amex_card_not_present_percent_fee')}
        name="amexCreditCardPercentFee"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:shop_form.fees.card_present_flat_fee')}</div>
      <CurrencyInput
        className="c-input"
        placeholder={t('admin:shop_form.fees.card_present_flat_fee')}
        name="presentCreditCardFlatFee"
        currency={currency}
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:shop_form.fees.card_present_percent_fee')}
      </div>
      <PercentageInput
        className="c-input"
        placeholder={t('admin:shop_form.fees.card_present_percent_fee')}
        name="presentCreditCardPercentFee"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:shop_form.fees.amex_card_present_flat_fee')}</div>
      <CurrencyInput
        className="c-input"
        placeholder={t('admin:shop_form.fees.amex_card_present_flat_fee')}
        name="amexPresentCreditCardFlatFee"
        currency={currency}
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:shop_form.fees.amex_card_present_percent_fee')}
      </div>
      <PercentageInput
        className="c-input"
        placeholder={t('admin:shop_form.fees.amex_card_present_percent_fee')}
        name="amexPresentCreditCardPercentFee"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">{t('admin:shop_form.fees.tap_to_pay_flat_fee')}</div>
      <CurrencyInput
        className="c-input"
        placeholder={t('admin:shop_form.fees.tap_to_pay_flat_fee')}
        name="tapToPayFlatFee"
        currency={currency}
      />
    </div>
  </div>
);

const FeesForm = ({
  currency,
  customerBookingFeeLimitEnabled,
  creditCardFeeEnabled,
  boothRentalEnabled,
  isRental,
}) => (
  <div>
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">
      {t('admin:shop_form.fees.title')}
    </div>
    <div className="c-wrapper-horizontal">
      <div className="layout">
        <CheckboxSwitch
          name="customerBookingFeeLimitEnabled"
          id="customerBookingFeeLimitEnabled"
          label={t('admin:shop_form.fees.rolling_squire_fees')}
          wrapperClass="layout__item"
        />
        <CheckboxSwitch
          display-if={customerBookingFeeLimitEnabled}
          name="legacyCustomerBookingFeeCalculation"
          id="legacyCustomerBookingFeeCalculation"
          label={t('admin:shop_form.fees.use_legacy_calculation')}
          wrapperClass="layout__item"
        />
        <div className="layout__item" display-if={!customerBookingFeeLimitEnabled}>
          <div className="c-label-new">{t('admin:shop_form.fees.client_booking_fee')}</div>
          <CurrencyInput
            className="c-input"
            placeholder={t('admin:shop_form.fees.client_booking_fee')}
            name="customerBookingFee"
            currency={currency}
          />
        </div>
        <div className="layout__item">
          <div className="c-label-new">{t('admin:shop_form.fees.waiting_list_fee')}</div>
          <CurrencyInput
            className="c-input"
            placeholder={t('admin:shop_form.fees.waiting_list_fee')}
            name="waitingListFee"
            currency={currency}
          />
        </div>
        <div className="layout__item" display-if={customerBookingFeeLimitEnabled}>
          <div className="c-label-new">{t('admin:shop_form.fees.first_tier_value')}</div>
          <CurrencyInput
            className="c-input"
            placeholder={t('admin:shop_form.fees.first_tier_value')}
            name="customerBookingFeeBottomLimit"
            currency={currency}
          />
        </div>
        <div className="layout__item" display-if={customerBookingFeeLimitEnabled}>
          <div className="c-label-new">{t('admin:shop_form.fees.second_tier_value')}</div>
          <CurrencyInput
            className="c-input"
            placeholder={t('admin:shop_form.fees.second_tier_value')}
            name="customerBookingFeeTopLimit"
            currency={currency}
          />
        </div>
        <CheckboxSwitch
          name="creditCardFeeEnabled"
          id="creditCardFeeEnabled"
          label={t('admin:shop_form.fees.credit_card_fee_enabled')}
          wrapperClass="layout__item"
        />
        {creditCardFeeEnabled && renderFees(currency)}
        <div className="layout__item">
          <div className="c-label-new">{t('admin:shop_form.fees.rapid_transfer_percentage_fee')}</div>
          <PercentageInput
            className="c-input"
            placeholder={t('admin:shop_form.fees.rapid_transfer_percentage_fee')}
            name="instantPayoutPercentageFee"
          />
        </div>
        <div className="layout__item c-heading--dark" display-if={!isRental}>
          <Icon glyph={GLYPHS.warning} />
          <span className="u-type--bold u-ml--">{t('admin:shop_form.fees.warning_label')}</span>
          <span> {t('admin:shop_form.fees.warning_message')}</span>
        </div>
        <CheckboxSwitch
          name="boothRentalEnabled"
          id="boothRentalEnabled"
          label={t('admin:shop_form.fees.rent_collect')}
          wrapperClass="layout__item"
        />
        <div className="layout__item" display-if={boothRentalEnabled}>
          <div className="c-label-new">{t('admin:shop_form.fees.rent_collect_fee')}</div>
          <PercentageInput
            className="c-input"
            placeholder={t('admin:shop_form.fees.rent_collect_fee')}
            name="boothRentalFee"
          />
        </div>
      </div>
    </div>
  </div>
);

FeesForm.propTypes = {
  currency: PropTypes.string.isRequired,
  creditCardFeeEnabled: PropTypes.bool.isRequired,
  customerBookingFeeLimitEnabled: PropTypes.bool.isRequired,
  boothRentalEnabled: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const selector = formValueSelector('editShop');

  return {
    boothRentalEnabled: selector(state, 'boothRentalEnabled'),
    creditCardFeeEnabled: selector(state, 'creditCardFeeEnabled'),
    customerBookingFeeLimitEnabled: selector(state, 'customerBookingFeeLimitEnabled'),
    isRental: parseInt(selector(state, 'kind'), 10) === SHOP_TYPE.rental,
  };
};

export default connect(mapStateToProps)(FeesForm);
